import styled from 'styled-components'
import { colors } from 'src/Global/Styles/variables'

interface ButtonProps {
  color?: string
  padding?: string
  maxWidth?: string
}

interface ButtonContainerProps {
  margin?: string
  justify?: string
}

export const BaseButton = styled.button<ButtonProps>`
  color: ${({ color }) => color};
  max-width: ${({ maxWidth }) => maxWidth};
  padding: ${({ padding }) => padding};
  border-radius: 0.25rem;
  transition: background 0.2s ease-in;
  width: 100%;
`

export const ButtonContainer = styled.div<ButtonContainerProps>`
  margin: ${({ margin }) => margin};
  display: flex;
  width: 100%;
  justify-content: ${({ justify }) => justify};
`

export const ButtonLink = styled.a`
  text-decoration: none;
  background-color: #f1f5f7;
  color: ${colors.grey};
  box-shadow: none;
  padding: 0.5rem 0.625rem;
  font-size: 1rem;
  line-height: 1.5rem;
`

export const TransparentButton = styled.button<ButtonProps>`
  background: none;
  color: ${({ color }) => color || `${colors.lightBlue}`};
  font-size: 1rem;
`

export const SecondaryButton = styled.button<ButtonProps>`
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth};
  background-color: #f1f5f7;
  color: ${({ color }) => color};
  padding: ${({ padding }) => padding};
  transition: background 0.2s ease-in;
`

export const PrimaryButton = styled.button<ButtonProps>`
  position: relative;
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth};
  background-color: ${({ disabled }) =>
    disabled ? colors.grey70 : colors.lightBlue};
  color: ${colors.white};
  padding: ${({ padding }) => padding};
  border-radius: 0.25rem;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition: background 0.2s ease-in;

  ${({ disabled }) => disabled && `opacity: 0.5;`}

  &:hover {
    background-color: ${({ disabled }) => (disabled ? 'none' : '#269dc9')};
  }
`
export const OutlinedButton = styled(BaseButton)`
  background: none;
  border: 0.125rem solid ${({ color }) => color};
`
